import React, { useEffect, useState } from "react";
import LayoutBuyerSeller from "../../components/layout/LayoutBuyerSeller";
import { Link, useNavigate } from "react-router-dom";
import AcceptInvitationModal from "../../components/models/AcceptInvitationModal";
import DeclineInvitationModal from "../../components/models/DeclineInvitationModal";
import apiService from "../../actions/apiService";
import { useAuth } from "../../context/authContext";

// Utility function to truncate text
const truncateText = (text, maxLength = 25) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const BuyerRequests = () => {
  const { user } = useAuth();
  const [acceptModalOpen, setAcceptModalOpen] = useState(false);
  const [declineModalOpen, setDeclineModalOpen] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [limit] = useState(100);
  const [selectedInvite, setSelectedInvite] = useState(null);
  const [selectedInviteDetails, setSelectedInviteDetails] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState("");
  const [deliveryFee, setDeliveryFee] = useState(null);
  const navigate = useNavigate();
  const renderStatusPill = (invite) => {
    // Check if item is cancelled first (takes priority over invitation status)
    if (invite?.item?.status === "cancelled") {
      return (
        <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#FF5040] text-white">
          <span role="img" aria-label="cross">
            <svg
              className="relative top-[2px]"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M9 3L3 9M3 3L9 9"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          Offer cancelled
        </div>
      );
    }

    const status = invite?.status;

    if (status === "pending") {
      return (
        <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#8794E0] text-[#ffffff]">
          <span role="img" aria-label="clock">
            <svg
              className="relative top-[1px]"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M4.5 9.25H7.5M3.3 1H8.7C8.98003 1 9.12004 1 9.227 1.0545C9.32108 1.10243 9.39757 1.17892 9.4455 1.273C9.5 1.37996 9.5 1.51997 9.5 1.8V2.83726C9.5 3.08185 9.5 3.20414 9.47237 3.31923C9.44787 3.42127 9.40747 3.51881 9.35264 3.60828C9.2908 3.7092 9.20432 3.79568 9.03137 3.96863L7.56569 5.43431C7.36768 5.63232 7.26867 5.73133 7.23158 5.84549C7.19895 5.94591 7.19895 6.05409 7.23158 6.15451C7.26867 6.26867 7.36768 6.36768 7.56568 6.56568L9.03137 8.03137C9.20432 8.20432 9.2908 8.2908 9.35264 8.39172C9.40747 8.48119 9.44787 8.57873 9.47237 8.68077C9.5 8.79586 9.5 8.91815 9.5 9.16274V10.2C9.5 10.48 9.5 10.62 9.4455 10.727C9.39757 10.8211 9.32108 10.8976 9.227 10.9455C9.12004 11 8.98003 11 8.7 11H3.3C3.01997 11 2.87996 11 2.773 10.9455C2.67892 10.8976 2.60243 10.8211 2.5545 10.727C2.5 10.62 2.5 10.48 2.5 10.2V9.16274C2.5 8.91815 2.5 8.79586 2.52763 8.68077C2.55213 8.57873 2.59253 8.48119 2.64736 8.39172C2.7092 8.2908 2.79568 8.20432 2.96863 8.03137L4.43432 6.56568C4.63232 6.36768 4.73133 6.26867 4.76842 6.15451C4.80105 6.05409 4.80105 5.94591 4.76842 5.84549C4.73133 5.73133 4.63232 5.63232 4.43431 5.43431L2.96863 3.96863C2.79568 3.79568 2.7092 3.7092 2.64736 3.60828C2.59253 3.51881 2.55213 3.42127 2.52763 3.31923C2.5 3.20414 2.5 3.08185 2.5 2.83726V1.8C2.5 1.51997 2.5 1.37996 2.5545 1.273C2.60243 1.17892 2.67892 1.10243 2.773 1.0545C2.87996 1 3.01997 1 3.3 1Z"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          Offer Received
        </div>
      );
    }

    if (status === "rejected") {
      return (
        <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#FF5040] text-white">
          <span role="img" aria-label="cross">
            <svg
              className="relative top-[2px]"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M9 3L3 9M3 3L9 9"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          Offer rejected
        </div>
      );
    }

    if (status === "accepted") {
      return (
        <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#00B72E] text-[#ffffff]">
          <span role="img" aria-label="check">
            <svg
              className="relative top-[2px]"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          Offer accepted
        </div>
      );
    }

    if (status === "expired" || status === "cancelled") {
      return (
        <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#5C31AC] text-[#ffffff]">
          <span role="img" aria-label="cross">
            <svg
              className="relative top-[2px]"
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <path
                d="M7 1L1 7M1 1L7 7"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          {status === "expired" ? "Offer expired" : "Offer declined"}
        </div>
      );
    }

    // Fallback to pending-style if unknown
    return (
      <div className="justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full bg-[#8794E0] text-[#ffffff]">
        <span role="img" aria-label="clock">
          <svg
            className="relative top-[1px]"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M4.5 9.25H7.5M3.3 1H8.7C8.98003 1 9.12004 1 9.227 1.0545C9.32108 1.10243 9.39757 1.17892 9.4455 1.273C9.5 1.37996 9.5 1.51997 9.5 1.8V2.83726C9.5 3.08185 9.5 3.20414 9.47237 3.31923C9.44787 3.42127 9.40747 3.51881 9.35264 3.60828C9.2908 3.7092 9.20432 3.79568 9.03137 3.96863L7.56569 5.43431C7.36768 5.63232 7.26867 5.73133 7.23158 5.84549C7.19895 5.94591 7.19895 6.05409 7.23158 6.15451C7.26867 6.26867 7.36768 6.36768 7.56568 6.56568L9.03137 8.03137C9.20432 8.20432 9.2908 8.2908 9.35264 8.39172C9.40747 8.48119 9.44787 8.57873 9.47237 8.68077C9.5 8.79586 9.5 8.91815 9.5 9.16274V10.2C9.5 10.48 9.5 10.62 9.4455 10.727C9.39757 10.8211 9.32108 10.8976 9.227 10.9455C9.12004 11 8.98003 11 8.7 11H3.3C3.01997 11 2.87996 11 2.773 10.9455C2.67892 10.8976 2.60243 10.8211 2.5545 10.727C2.5 10.62 2.5 10.48 2.5 10.2V9.16274C2.5 8.91815 2.5 8.79586 2.52763 8.68077C2.55213 8.57873 2.59253 8.48119 2.64736 8.39172C2.7092 8.2908 2.79568 8.20432 2.96863 8.03137L4.43432 6.56568C4.63232 6.36768 4.73133 6.26867 4.76842 6.15451C4.80105 6.05409 4.80105 5.94591 4.76842 5.84549C4.73133 5.73133 4.63232 5.63232 4.43431 5.43431L2.96863 3.96863C2.79568 3.79568 2.7092 3.7092 2.64736 3.60828C2.59253 3.51881 2.55213 3.42127 2.52763 3.31923C2.5 3.20414 2.5 3.08185 2.5 2.83726V1.8C2.5 1.51997 2.5 1.37996 2.5545 1.273C2.60243 1.17892 2.67892 1.10243 2.773 1.0545C2.87996 1 3.01997 1 3.3 1Z"
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>{" "}
        Offer Received
      </div>
    );
  };

  useEffect(() => {
    const fetchInvitations = async () => {
      setLoading(true);
      setError("");
      const res = await apiService.get("/items/buyer/invitations", {
        page: 1,
        limit,
      });
      if (res.success) {
        const invites = res?.data?.invites || [];
        setInvitations(invites);
      } else {
        setError(res.error || "Failed to load invitations");
      }
      setLoading(false);
    };
    fetchInvitations();
  }, [limit]);

  const handleAcceptRequest = async (invite) => {
    setSelectedInvite(invite || null);
    setSelectedInviteDetails(null);
    setActionError("");
    // Best-effort fetch of authentication fee for items that support it
    if (invite?.item?.delivered_to_door && !deliveryFee) {
      try {
        const feeRes = await apiService.get("/transactions/delivery-fee");
        if (feeRes.success && feeRes.data?.delivery_fee) {
          setDeliveryFee(Number(feeRes.data.delivery_fee));
        }
      } catch (_) {
        // ignore; modal will show "Not available"
      }
    }

    // Fetch invite details so we can prefill authentication if it was already selected via offer/transaction
    // (the list endpoint doesn't include acceptedOffer/transactions).
    if (invite?.id) {
      try {
        const detailsRes = await apiService.get(
          `/items/buyer/invitations/${invite.id}/details`
        );
        if (detailsRes.success) {
          setSelectedInviteDetails(detailsRes.data);
        }
      } catch (_) {
        // ignore; modal will still work, just without prefilling
      }
    }
    setAcceptModalOpen(true);
  };

  const handleDeclineRequest = (invite) => {
    setSelectedInvite(invite || null);
    setActionError("");
    setDeclineModalOpen(true);
  };

  const handleCloseAcceptModal = () => {
    setAcceptModalOpen(false);
    setSelectedInviteDetails(null);
  };

  const handleCloseDeclineModal = () => {
    setDeclineModalOpen(false);
  };

  const handleConfirmAccept = async (includeAuthentication) => {
    if (!selectedInvite?.id) {
      setAcceptModalOpen(false);
      return;
    }
    const wantsAuthentication = Boolean(
      includeAuthentication && selectedInvite?.item?.delivered_to_door
    );
    if (wantsAuthentication && !deliveryFee) {
      setActionError(
        "Authentication fee information is not available. Please try again."
      );
      return;
    }
    setActionLoading(true);
    setActionError("");
    const res = await apiService.patch(`/invites/${selectedInvite.id}/accept`, {
      is_delivered_door: wantsAuthentication,
    });
    if (res.success) {
      setInvitations((prev) =>
        (prev || []).map((inv) =>
          inv?.id === selectedInvite.id ? { ...inv, status: "accepted" } : inv
        )
      );
      navigate(`/buyer/payment-initiate/${selectedInvite?.item?.id}`);
      setAcceptModalOpen(false);
      setSelectedInvite(null);
    } else {
      setActionError(res.error || "Failed to accept invitation");
    }
    setActionLoading(false);
  };

  const handleConfirmDecline = async () => {
    if (!selectedInvite?.id) {
      setDeclineModalOpen(false);
      return;
    }
    setActionLoading(true);
    setActionError("");
    const res = await apiService.delete(`/invites/${selectedInvite.id}/cancel`);
    if (res.success) {
      setInvitations((prev) =>
        (prev || []).map((inv) =>
          inv?.id === selectedInvite.id ? { ...inv, status: "cancelled" } : inv
        )
      );
      setDeclineModalOpen(false);
      setSelectedInvite(null);
    } else {
      setActionError(res.error || "Failed to cancel invitation");
    }
    setActionLoading(false);
  };

  return (
    <LayoutBuyerSeller>
      <div className="absolute lg:hidden top-0 left-0 h-72 w-full bg-blue-gradient"></div>
      <div className="relative z-[10]">
        <div className="flex px-5 items-center justify-between">
          <div>
            <h2 className="text-page-title md:text-page-title-d text-white lg:text-[#1E1E1E] font-rubik">
              Invitations
            </h2>
            <p className="text-small-price opacity-50 mt-4 md:text-small-price text-white lg:text-[#1E1E1E] !font-normal">
              Find cars, watches, Bags, and properties
            </p>
          </div>
        </div>

        <div className="mt-8 space-y-8 px-5 md:px-0">
          {/* No Invitations */}

          {invitations.length === 0 && !loading && (
            <section className="bg-white border flex flex-col justify-center items-center rounded-[12px] border-[#DCEDFF] p-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  d="M6.54 13.9198L24 24.0198L41.46 13.9198M24 44.1598V23.9998M42 31.9998V15.9998C41.9993 15.2984 41.8141 14.6094 41.4631 14.0021C41.112 13.3948 40.6075 12.8905 40 12.5398L26 4.5398C25.3919 4.18873 24.7021 4.00391 24 4.00391C23.2979 4.00391 22.6081 4.18873 22 4.5398L8 12.5398C7.39253 12.8905 6.88796 13.3948 6.53692 14.0021C6.18589 14.6094 6.00072 15.2984 6 15.9998V31.9998C6.00072 32.7013 6.18589 33.3902 6.53692 33.9975C6.88796 34.6048 7.39253 35.1091 8 35.4598L22 43.4598C22.6081 43.8109 23.2979 43.9957 24 43.9957C24.7021 43.9957 25.3919 43.8109 26 43.4598L40 35.4598C40.6075 35.1091 41.112 34.6048 41.4631 33.9975C41.8141 33.3902 41.9993 32.7013 42 31.9998Z"
                  stroke="#2A8BF7"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <h3 className="text-big-price my-8 md:text-big-price-d font-[500] font-rubik text-[#1E1E1E]">
                How item search works
              </h3>
              <p className="text-[16px] opacity-50 text-[#000025] font-[400]">
                Find and purchase luxury items through our platform.
              </p>
            </section>
          )}

          {/* Requests table */}
          {invitations.length > 0 && (
            <section className="rounded-[12px] bg-[#F5F8FF]">
              <div className="bg-white border rounded-[12px] border-[#DCEDFF] overflow-hidden">
                <div className="w-full overflow-x-auto">
                  <table className="w-[97%] mx-auto mt-5 mb-2 min-w-[900px]">
                    <thead className="bg-[#1E1E1E0D] text-subsection-title-d text-[#1E1E1E]">
                      <tr>
                        <th className="text-left min-w-[250px] py-3 px-5 rounded-tl-[12px]">
                          Listing
                        </th>
                        <th className="text-left min-w-[250px] py-3 px-5">
                          Seller
                        </th>
                        <th className="text-left min-w-[150px] py-3 px-5">
                          Offer
                        </th>
                        <th className="text-left min-w-[220px] py-3 px-5">
                          Status
                        </th>
                        <th className="text-left py-3 px-5 rounded-tr-[12px]">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invitations.map((i, idx) => (
                        <tr key={idx} className="border-t border-gray-100">
                          <td className="py-3 px-5">
                            <div className="flex items-center gap-4">
                              <div className="h-[48px] w-[48px] bg-gray-100 rounded overflow-hidden">
                                {i?.item?.images?.[0]?.file_url ? (
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}${i?.item?.images?.[0]?.file_url}`}
                                    alt="thumb"
                                    className="h-full w-full object-cover"
                                  />
                                ) : (
                                  <span className="h-[48px] w-[48px] flex items-center justify-center bg-gray-100 rounded text-gray-500">
                                    {"N/A"}
                                  </span>
                                )}
                              </div>
                              <div>
                                <div className="text-product-title text-esdarkGray line-clamp-1">
                                  {truncateText(i?.item?.title)}
                                </div>
                                <div className="text-[14px] opacity-75 text-[#000025]">
                                  {i?.item?.custom_category
                                    ? `${i?.item?.custom_category}`
                                    : i?.item?.category}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="py-3 px-5">
                            <div className="flex items-center gap-4">
                              {user?.profile_image_url ? (
                                <img
                                  src={user?.profile_image_url}
                                  alt="avatar"
                                  className="h-8 w-8 rounded-full object-cover"
                                />
                              ) : (
                                <span className="text-slate-600 rounded-full object-cover bg-slate-200 w-8 h-8 text-xl font-semibold flex items-center justify-center">
                                  {i?.item?.seller?.firstName?.charAt(0) +
                                    i?.item?.seller?.lastName?.charAt(0)}
                                </span>
                              )}
                              <div>
                                <div className="text-esdarkGray opacity-75 text-nav-d">
                                  {i?.item?.seller?.firstName &&
                                    i?.item?.seller?.lastName && (
                                      <>
                                        {i?.item?.seller?.firstName +
                                          " " +
                                          i?.item?.seller?.lastName}
                                      </>
                                    )}
                                  {!i?.item?.seller?.firstName &&
                                    !i?.item?.seller?.lastName && <>N/A</>}
                                </div>
                                <div className="text-[12px] opacity-50 text-esdarkGray">
                                  {i?.item?.seller?.email}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="py-3 px-5 text-[#000025] text-page-subtitle-d">
                            {i?.item?.price} €
                          </td>
                          <td className="py-3 px-5">
                            <span
                              className={`text-[14px] justify-start items-center flex gap-1 font-medium w-fit px-2.5 py-1 rounded-full `}
                            >
                              {renderStatusPill(i)}
                            </span>
                          </td>
                          <td className="py-3 px-5">
                            <div className="flex items-center gap-4">
                              <Link
                                to={`/buyer/requests/${i?.id}/offer`}
                                title="Message"
                                className="h-10 w-fit px-3 flex items-center justify-center border border-gray-200 gap-4 rounded-[8px] bg-[#FFFFFF] text-[#1E1E1E] border:opacity-50"
                              >
                                <span className="text-[14px] font-[600]">
                                  View
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g opacity="0.5">
                                    <path
                                      d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
                                      stroke="#1E1E1E"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
                                      stroke="#1E1E1E"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                </svg>
                              </Link>
                              <div className="flex justify-center items-center gap-4">
                                {i?.item?.status === "cancelled" ? (
                                  <div className="flex gap-2 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      className="min-w-[14px] min-h-[14px]"
                                    >
                                      <path
                                        d="M13 1L1 13M1 1L13 13"
                                        stroke="#6B7280"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-gray-600 font-[600] text-[14px]">
                                      Cancelled
                                    </span>
                                  </div>
                                ) : i?.status === "rejected" ? (
                                  <div className="flex gap-2 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      className="min-w-[14px] min-h-[14px]"
                                    >
                                      <path
                                        d="M13 1L1 13M1 1L13 13"
                                        stroke="#DC2626"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-[#DC2626] font-[600] text-[14px]">
                                      Rejected
                                    </span>
                                  </div>
                                ) : i?.status === "pending" ? (
                                  <>
                                    <button
                                      title="Approve"
                                      onClick={() => handleAcceptRequest(i)}
                                      className="h-10 w-10 flex items-center justify-center rounded-[8px] transition-colors bg-[#B9FFCC] text-esdarkGray"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="13"
                                        viewBox="0 0 18 13"
                                        fill="none"
                                      >
                                        <path
                                          d="M17 1L6 12L1 7"
                                          stroke="#1E1E1E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      title="Reject"
                                      onClick={() => handleDeclineRequest(i)}
                                      className="h-10 w-10 flex items-center justify-center rounded-[8px] transition-colors bg-[#FFD9D9] text-[#FF6E6E]"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                      >
                                        <path
                                          d="M13 1L1 13M1 1L13 13"
                                          stroke="#FF6E6E"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                ) : i?.status === "accepted" ? (
                                  <div className="flex gap-2 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="13"
                                      viewBox="0 0 18 13"
                                      fill="none"
                                      className="min-w-[18px] min-h-[13px]"
                                    >
                                      <path
                                        d="M17 1L6 12L1 7"
                                        stroke="#16653F"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-[#16653F] font-[600] text-[14px]">
                                      Invitation accepted
                                    </span>
                                  </div>
                                ) : (
                                  <div className="flex gap-2 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      className="min-w-[14px] min-h-[14px]"
                                    >
                                      <path
                                        d="M13 1L1 13M1 1L13 13"
                                        stroke="#FF0202"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-[#FF0202] font-[600] text-[14px]">
                                      Declined
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}

                      {/* Error and Loading rows */}
                      {error && (
                        <tr>
                          <td colSpan={5} className="py-6">
                            <div className="w-full flex items-center justify-center">
                              <div className="">
                                <div className="font-medium">
                                  Failed to load invitations
                                </div>
                                <div className="text-sm opacity-80 mt-1">
                                  {error}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}

                      {loading && (
                        <tr>
                          <td colSpan={5} className="py-6">
                            <div className="w-full flex items-center justify-center text-[#1E1E1E]">
                              <span className="ml-3">
                                Loading invitations...
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                      {actionLoading && (
                        <tr>
                          <td colSpan={5} className="py-4">
                            <div className="w-full flex items-center justify-center text-[#1E1E1E] text-sm">
                              Processing...
                            </div>
                          </td>
                        </tr>
                      )}
                      {actionError && (
                        <tr>
                          <td colSpan={5} className="py-4">
                            <div className="w-full flex items-center justify-center">
                              <div className="text-red-600 text-sm">
                                {actionError}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          )}

          {/* How it works */}
          <section className="bg-white border rounded-[12px] border-[#DCEDFF] p-5">
            <h3 className="text-big-price md:text-big-price-d font-[500] font-rubik text-[#1E1E1E]">
              How invitations work
            </h3>
            <p className="text-[16px] opacity-50 text-[#000025] mt-2 font-[400]">
              Find and purchase luxury items through our plateform.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
              {/* Step 1 */}
              <div className="rounded-[12px] border border-[#DCEDFF] p-5">
                <div className="flex flex-col items-start gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                      stroke="#2A8BF7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div>
                    <div className="font-[500] text-big-price md:text-big-price-d text-[#1E1E1E]">
                      Step 1: Receive invitation
                    </div>
                    <p className="mt-4 text-[16px] opacity-50 text-[#000025] font-[400]">
                      Seller send email invitation to you
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="rounded-[12px] border border-[#DCEDFF] p-5">
                <div className="flex flex-col items-start gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M10.3334 11.5347C11.5669 10.8218 13.0997 10.8218 14.3333 11.5347M9.1618 9.17157C10.7239 10.7337 10.7239 13.2663 9.1618 14.8284C7.59971 16.3905 5.06705 16.3905 3.50494 14.8284C1.94285 13.2663 1.94285 10.7337 3.50494 9.17157C5.06704 7.60948 7.5997 7.60948 9.1618 9.17157ZM21.1618 9.17157C22.7239 10.7337 22.7239 13.2663 21.1618 14.8284C19.5997 16.3905 17.067 16.3905 15.5049 14.8284C13.9429 13.2663 13.9429 10.7337 15.5049 9.17157C17.067 7.60948 19.5997 7.60948 21.1618 9.17157Z"
                      stroke="#2A8BF7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div>
                    <div className="font-[500] text-big-price md:text-big-price-d text-[#1E1E1E]">
                      Step 2: View item
                    </div>
                    <p className="mt-4 text-[16px] opacity-50 text-[#000025] font-[400]">
                      Review detailed item information and photos.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="rounded-[12px] border border-[#DCEDFF] p-5">
                <div className="flex flex-col items-start gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M6.66663 16C6.66663 18.2091 8.45749 20 10.6666 20H14.6666C16.8758 20 18.6666 18.2091 18.6666 16C18.6666 13.7909 16.8758 12 14.6666 12H10.6666C8.45749 12 6.66663 10.2091 6.66663 8C6.66663 5.79086 8.45749 4 10.6666 4H14.6666C16.8758 4 18.6666 5.79086 18.6666 8M12.6666 2V22"
                      stroke="#2A8BF7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div>
                    <div className="font-[500] text-big-price md:text-big-price-d text-[#1E1E1E]">
                      Step 3: Secure payment
                    </div>
                    <p className="mt-4 text-[16px] opacity-50 text-[#000025] font-[400]">
                      Pay through escrow.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="rounded-[12px] border border-[#DCEDFF] p-5">
                <div className="flex flex-col items-start gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20.5 7.27832L12 12.0005M12 12.0005L3.49997 7.27832M12 12.0005L12 21.5006M21 16.0591V7.94202C21 7.59937 21 7.42805 20.9495 7.27526C20.9049 7.14008 20.8318 7.016 20.7354 6.91131C20.6263 6.79297 20.4766 6.70977 20.177 6.54337L12.777 2.43225C12.4934 2.2747 12.3516 2.19592 12.2015 2.16503C12.0685 2.1377 11.9315 2.1377 11.7986 2.16503C11.6484 2.19592 11.5066 2.2747 11.223 2.43226L3.82297 6.54337C3.52345 6.70977 3.37369 6.79297 3.26463 6.91131C3.16816 7.016 3.09515 7.14008 3.05048 7.27526C3 7.42806 3 7.59938 3 7.94202V16.0591C3 16.4018 3 16.5731 3.05048 16.7259C3.09515 16.8611 3.16816 16.9851 3.26463 17.0898C3.37369 17.2082 3.52345 17.2914 3.82297 17.4578L11.223 21.5689C11.5066 21.7264 11.6484 21.8052 11.7986 21.8361C11.9315 21.8634 12.0685 21.8634 12.2015 21.8361C12.3516 21.8052 12.4934 21.7264 12.777 21.5689L20.177 17.4578C20.4766 17.2914 20.6263 17.2082 20.7354 17.0898C20.8318 16.9851 20.9049 16.8611 20.9495 16.7259C21 16.5731 21 16.4018 21 16.0591Z"
                      stroke="#2A8BF7"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.5 9.5L7.5 4.5"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div>
                    <div className="font-[500] text-big-price md:text-big-price-d text-[#1E1E1E]">
                      Step 4: Confirm receipt
                    </div>
                    <p className="mt-4 text-[16px] opacity-50 text-[#000025] font-[400]">
                      Confirm item received to complete transaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Accept Request Modal */}
      <AcceptInvitationModal
        isOpen={acceptModalOpen}
        onClose={handleCloseAcceptModal}
        onAccept={handleConfirmAccept}
        buyerName={
          selectedInvite?.item?.seller?.firstName +
            " " +
            selectedInvite?.item?.seller?.lastName || ""
        }
        itemName={selectedInvite?.item?.title || ""}
        itemSupportsDelivery={Boolean(selectedInvite?.item?.delivered_to_door)}
        deliveryFee={deliveryFee}
        defaultIncludeDeliveryFee={Boolean(
          selectedInviteDetails?.acceptedOffer?.is_delivered_door !== undefined
            ? selectedInviteDetails?.acceptedOffer?.is_delivered_door
            : selectedInviteDetails?.item?.transactions?.[0]
                ?.is_delivered_door === true
        )}
        lockDeliveryOption={Boolean(
          selectedInviteDetails?.acceptedOffer?.is_delivered_door !== undefined
        )}
      />

      {/* Decline Request Modal */}
      <DeclineInvitationModal
        isOpen={declineModalOpen}
        onClose={handleCloseDeclineModal}
        onDecline={handleConfirmDecline}
        buyerName={
          selectedInvite?.item?.seller?.firstName +
            " " +
            selectedInvite?.item?.seller?.lastName || ""
        }
        itemName={selectedInvite?.item?.title || ""}
      />
    </LayoutBuyerSeller>
  );
};

export default BuyerRequests;
